import { isEmpty } from 'lodash/fp';

import { ProductType } from '../../../../types/product';

const getCarouselStartIndex = (
  recommendedProductId: ProductType['id'] | ProductType['parentProductId'] | null,
  products: ProductType[],
  selectedProductId: ProductType['id'] | null,
) => {
  let index = 0;

  if (isEmpty(products)) return index;

  if (selectedProductId) {
    index = products.findIndex((product) => product.id === selectedProductId);
  } else {
    index = products.findIndex((product) => (product.parentProductId || product.id) === recommendedProductId);
  }
  return index === -1 ? 0 : index;
};

export default getCarouselStartIndex;
